export enum PassportGroupPassportTypeEnum {
  ERKNM = 'ERKNM',
  PM = 'PM',
  DECISION_PASSPORT = 'DECISION_PASSPORT',
  ERP = 'ERP',
}
